import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lme_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CATEGORIES = [
  { key: "all", label: "All", color: "text-white" },
  { key: "concert", label: "Concerts", color: "text-violet-400" },
  { key: "sports", label: "Sports", color: "text-emerald-400" },
  { key: "dinner", label: "Dinner", color: "text-rose-400" },
  { key: "business", label: "Business", color: "text-cyan-400" },
  { key: "social", label: "Social", color: "text-amber-400" },
  { key: "other", label: "Other", color: "text-slate-300" },
];

export const CATEGORY_META = {
  concert: { color: "violet", label: "Concert" },
  sports: { color: "emerald", label: "Sports" },
  dinner: { color: "rose", label: "Dinner" },
  business: { color: "cyan", label: "Business" },
  social: { color: "amber", label: "Social" },
  other: { color: "slate", label: "Other" },
};
